// Cartão padrão (fundo branco, borda cinza clara, cantos bem arredondados, sombra
// leve). Esse é o padrão visual mais repetido no sistema hoje — codificado aqui
// pra telas novas usarem em vez de reescrever a mesma className toda vez.
// Não é uma migração das telas existentes (isso seria só cosmético em ~15
// arquivos, sem corrigir duplicação de lógica nenhuma) — é pra uso daqui pra frente.
import React, { forwardRef } from 'react';

const PADDINGS = {
  none: '',
  sm: 'p-2',
  md: 'p-3',
  lg: 'p-4',
};

const Card = forwardRef(function Card({ children, className = '', padding = 'md', onScroll, onWheel }, ref) {
  return (
    <div
      ref={ref}
      onScroll={onScroll}
      onWheel={onWheel}
      className={`bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm ${PADDINGS[padding] ?? PADDINGS.md} ${className}`}
    >
      {children}
    </div>
  );
});

export default Card;
